import { useCarlineStore } from '../store/carline';
export const useDebugMode = () => {
    const { isDebugMode } = useCarlineStore();
    const getName = (item) => {
        if (!isDebugMode) {
            return item ? item === null || item === void 0 ? void 0 : item.name : undefined;
        }
        return (item === null || item === void 0 ? void 0 : item.name) ? `${item === null || item === void 0 ? void 0 : item.name} [${item.pr7}]` : undefined;
    };
    const getDebugCode = (selectedEngine) => {
        var _a;
        const model = selectedEngine.modelId;
        return `${model.code}\\${model.version}${((_a = model.extensionsPR7) === null || _a === void 0 ? void 0 : _a.length) ? `\\${model.extensionsPR7.join('\\')}` : ''}\\${model.year}`;
    };
    return { getName, getDebugCode, isDebug: isDebugMode };
};
